// @ts-nocheck
/* eslint-disable */
export const marketplaceIcon = {
        data: `<svg
    class="management-nav-icon"
    viewBox="0 0 100 100"
    fill="none">
 <path
        class="lower-hexagon"
        d="M48.0833 2.83864C49.2694 2.15388 50.7306 2.15388 51.9167 2.83864L89.8846 24.7594C91.0706 25.4442 91.8013 26.7097 91.8013 28.0792V71.9208C91.8013 73.2903 91.0706 74.5558 89.8846 75.2406L51.9167 97.1614C50.7306 97.8461 49.2694 97.8461 48.0833 97.1614L10.1154 75.2406C8.92936 74.5558 8.19873 73.2903 8.19873 71.9208V28.0792C8.19873 26.7097 8.92936 25.4442 10.1154 24.7594L48.0833 2.83864Z"
        stroke-width="3" />
    <g style="mix-blend-mode: soft-light">
        <path
            class="upper-hexagon-shade"
            d="M50 8L87 29.7166V48.2875C87 48.2875 76.7767 57 50 57C24.6328 57 13 48.2875 13 48.2875V30L50 8Z" />
        <path
            d="M14 30.5688L50.0033 9.16146L86 30.2892V47.7954C85.9763 47.8127 85.9514 47.8308 85.9252 47.8495C85.6165 48.0712 85.1369 48.3955 84.474 48.7888C83.1485 49.5752 81.0886 50.6379 78.1951 51.7056C72.4099 53.8403 63.2778 56 50 56C37.4335 56 28.2975 53.8424 22.3246 51.7024C19.3372 50.632 17.1385 49.565 15.6954 48.7724C14.9739 48.376 14.4412 48.0482 14.0932 47.8227C14.0605 47.8015 14.0294 47.7812 14 47.7618V30.5688Z"
            stroke="black"
            stroke-opacity="0.01"
            stroke-width="2" />
    </g>

  <path
        d="M68.9489 69.9343H31.1166C30.486 69.9343 30.0657 69.514 30.0657 68.8834C30.0657 68.2529 30.486 67.8325 31.1166 67.8325H68.9489C69.5795 67.8325 69.9998 68.2529 69.9998 68.8834C69.9998 69.514 69.5795 69.9343 68.9489 69.9343Z"
        fill="var(--icon-text)" />
    <path
        d="M65.7963 69.9341H34.2693C33.6387 69.9341 33.2184 69.5138 33.2184 68.8832V48.9161C33.2184 48.2856 33.6387 47.8652 34.2693 47.8652C34.8998 47.8652 35.3202 48.2856 35.3202 48.9161V67.8323H64.7454V48.9161C64.7454 48.2856 65.1657 47.8652 65.7963 47.8652C66.4268 47.8652 66.8472 48.2856 66.8472 48.9161V68.8832C66.8472 69.5138 66.4268 69.9341 65.7963 69.9341Z"
        fill="var(--icon-text)" />
    <path
        d="M34.2693 49.9669C31.9573 49.9669 30.0657 48.0753 30.0657 45.7633C30.0657 45.1328 30.486 44.7124 31.1166 44.7124C31.7471 44.7124 32.1675 45.1328 32.1675 45.7633C32.1675 46.9193 33.1133 47.8651 34.2693 47.8651C35.4253 47.8651 36.3711 46.9193 36.3711 45.7633C36.3711 45.1328 36.7914 44.7124 37.422 44.7124C38.0525 44.7124 38.4729 45.1328 38.4729 45.7633C38.4729 48.0753 36.5812 49.9669 34.2693 49.9669Z"
        fill="var(--icon-text)" />
    <path
        d="M40.5747 49.9669C38.2627 49.9669 36.3711 48.0753 36.3711 45.7633C36.3711 45.1328 36.7914 44.7124 37.422 44.7124C38.0525 44.7124 38.4729 45.1328 38.4729 45.7633C38.4729 46.9193 39.4187 47.8651 40.5747 47.8651C41.7306 47.8651 42.6765 46.9193 42.6765 45.7633C42.6765 45.1328 43.0968 44.7124 43.7274 44.7124C44.3579 44.7124 44.7783 45.1328 44.7783 45.7633C44.7783 48.0753 42.8866 49.9669 40.5747 49.9669Z"
        fill="var(--icon-text)" />
    <path
        d="M46.8801 49.9669C44.5681 49.9669 42.6765 48.0753 42.6765 45.7633C42.6765 45.1328 43.0968 44.7124 43.7274 44.7124C44.3579 44.7124 44.7783 45.1328 44.7783 45.7633C44.7783 46.9193 45.7241 47.8651 46.8801 47.8651C48.0361 47.8651 48.9819 46.9193 48.9819 45.7633C48.9819 45.1328 49.4022 44.7124 50.0328 44.7124C50.6633 44.7124 51.0837 45.1328 51.0837 45.7633C51.0837 48.0753 49.1921 49.9669 46.8801 49.9669Z"
        fill="var(--icon-text)" />
    <path
        d="M53.1855 49.9669C50.8735 49.9669 48.9819 48.0753 48.9819 45.7633C48.9819 45.1328 49.4022 44.7124 50.0328 44.7124C50.6633 44.7124 51.0837 45.1328 51.0837 45.7633C51.0837 46.9193 52.0295 47.8651 53.1855 47.8651C54.3415 47.8651 55.2873 46.9193 55.2873 45.7633C55.2873 45.1328 55.7076 44.7124 56.3382 44.7124C56.9687 44.7124 57.3891 45.1328 57.3891 45.7633C57.3891 48.0753 55.4974 49.9669 53.1855 49.9669Z"
        fill="var(--icon-text)" />
    <path
        d="M59.4909 49.9669C57.1789 49.9669 55.2873 48.0753 55.2873 45.7633C55.2873 45.1328 55.7076 44.7124 56.3382 44.7124C56.9687 44.7124 57.3891 45.1328 57.3891 45.7633C57.3891 46.9193 58.3349 47.8651 59.4909 47.8651C60.6468 47.8651 61.5927 46.9193 61.5927 45.7633C61.5927 45.1328 62.013 44.7124 62.6436 44.7124C63.2741 44.7124 63.6945 45.1328 63.6945 45.7633C63.6945 48.0753 61.8028 49.9669 59.4909 49.9669Z"
        fill="var(--icon-text)" />
    <path
        d="M65.7962 49.9669C63.4843 49.9669 61.5927 48.0753 61.5927 45.7633C61.5927 45.1328 62.013 44.7124 62.6436 44.7124C63.2741 44.7124 63.6944 45.1328 63.6944 45.7633C63.6944 46.9193 64.6403 47.8651 65.7962 47.8651C66.9522 47.8651 67.898 46.9193 67.898 45.7633C67.898 45.1328 68.3184 44.7124 68.9489 44.7124C69.5795 44.7124 69.9998 45.1328 69.9998 45.7633C69.9998 48.0753 68.1082 49.9669 65.7962 49.9669Z"
        fill="var(--icon-text)" />
    <path
        d="M31.1167 46.8144C31.0116 46.8144 30.9066 46.8144 30.6964 46.7093C30.1709 46.4991 29.8557 45.8686 30.0658 45.3431L34.2694 34.8342C34.4796 34.4138 34.9 34.2036 35.3203 34.2036H40.5748C41.2054 34.2036 41.6257 34.624 41.6257 35.2545C41.6257 35.8851 41.2054 36.3054 40.5748 36.3054H36.056L32.1676 46.1839C31.9575 46.6042 31.5371 46.8144 31.1167 46.8144Z"
        fill="var(--icon-text)" />
    <path
        d="M68.9489 46.8144C68.5286 46.8144 68.1082 46.6042 68.0031 46.1839L64.0097 36.3054H59.4908C58.8603 36.3054 58.4399 35.8851 58.4399 35.2545C58.4399 34.624 58.8603 34.2036 59.4908 34.2036H64.7453C65.1657 34.2036 65.5861 34.4138 65.6911 34.8342L69.8947 45.3431C70.1049 45.8686 69.8947 46.4991 69.2642 46.7093C69.1591 46.8144 69.054 46.8144 68.9489 46.8144Z"
        fill="var(--icon-text)" />
    <path
        d="M56.3382 41.5599H43.7274C41.4154 41.5599 39.5238 39.6683 39.5238 37.3563V34.2036C39.5238 31.8916 41.4154 30 43.7274 30H56.3382C58.6501 30 60.5418 31.8916 60.5418 34.2036V37.3563C60.5418 39.6683 58.6501 41.5599 56.3382 41.5599ZM43.7274 32.1018C42.5714 32.1018 41.6256 33.0476 41.6256 34.2036V37.3563C41.6256 38.5123 42.5714 39.4581 43.7274 39.4581H56.3382C57.4941 39.4581 58.44 38.5123 58.44 37.3563V34.2036C58.44 33.0476 57.4941 32.1018 56.3382 32.1018H43.7274Z"
        fill="var(--icon-text)" />
    <path
        d="M57.1111 65H42.8889C42.3556 65 42 64.6308 42 64.0769V53.9231C42 53.3692 42.3556 53 42.8889 53H57.1111C57.6444 53 58 53.3692 58 53.9231V64.0769C58 64.6308 57.6444 65 57.1111 65ZM43.7778 63.1538H56.2222V54.8462H43.7778V63.1538Z"
        fill="var(--icon-text)" />


      <defs>
        <linearGradient
            id="paint0_linear_dark"
            x1="48.4375"
            y1="3.125"
            x2="73.4375"
            y2="87.5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#4FC8EC" />
            <stop
                offset="1"
                stop-color="#2D3792" />
        </linearGradient>
        <linearGradient
            id="paint1_linear_dark"
            x1="50"
            y1="100"
            x2="50"
            y2="7.11531e-07"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#2D3792" />
            <stop
                offset="1"
                stop-color="#4FC8EC" />
        </linearGradient>
        <linearGradient
            id="paint2_linear_dark"
            x1="48.5908"
            y1="7.99662"
            x2="60.3796"
            y2="64.1636"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#ADAFB1" />
            <stop
                offset="1"
                stop-color="#CCCDCF" />
        </linearGradient>

        <linearGradient
            id="paint0_linear_light"
            x1="48.4375"
            y1="3.125"
            x2="73.4375"
            y2="87.5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#1D53A4" />
            <stop
                offset="1"
                stop-color="#1C3664" />
        </linearGradient>
        <linearGradient
            id="paint1_linear_light"
            x1="50"
            y1="100"
            x2="50"
            y2="7.11531e-07"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#1C3664" />
            <stop
                offset="1"
                stop-color="#1D53A4" />
        </linearGradient>
        <linearGradient
            id="paint2_linear_light"
            x1="48.5908"
            y1="7.99662"
            x2="60.3796"
            y2="64.1636"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#ADAFB1" />
            <stop
                offset="1"
                stop-color="#CCCDCF" />
        </linearGradient>
    </defs>
</svg>`, 
name: 'marketplace' as const
};